export const GET_SHIP_NODES = 'GET_SHIP_NODES';
export const GET_SHIP_NODE_BY_ID = 'GET_SHIP_NODE_BY_ID';
export const UPDATE_SHIP_NODE = 'UPDATE_SHIP_NODE';
export const DELETE_SHIP_NODE = 'DELETE_SHIP_NODE';
export const CREATE_SHIP_NODE = 'CREATE_SHIP_NODE';
